/**
 * Affiliate Registration Page for trAInedup.ai
 * Post-payment registration page for Offer Lab users
 */

import React from 'react';
import { Layout } from '../components/common/Layout';
import { AffiliateRegistrationForm } from '../components/auth/AffiliateRegistrationForm';

/**
 * Affiliate registration page component
 * Renders the registration form for users who have already paid via Offer Lab
 */
export const AffiliateRegistrationPage: React.FC = () => {
  return (
    <Layout showFooter={false} showHeader={false} showUpgradeBanner={false} showChatbot={false}>
      <div className="min-h-screen bg-gradient-to-br from-primary-50 to-secondary-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-3xl">
          <AffiliateRegistrationForm />
        </div>
      </div>
    </Layout>
  );
};
